import classNames from 'classnames';
import * as React from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';

import { MultipleLineTruncate } from '../../../common/LineTruncate';
import StringUtils from '../../../utils/StringUtils';
import css from './BooksMenuDescription.module.scss';

interface OwnProps {
  className?: string;
  text: string;
}

type Props = OwnProps & InjectedIntlProps;

const BooksMenuDescription = (props: Props) => {
  const [ellipsis, setEllipsis] = React.useState(true);
  const [clampedState, setClampedState] = React.useState(true);

  const classes = classNames(css.BooksMenuDescription, props.className);

  return (
    <div className={classes}>
      {ellipsis ? (
        <MultipleLineTruncate
          className={css.BooksMenuDescription__Text}
          maxLine={7}
          onReflow={({ clamped }) => setClampedState(!!clamped)}
          text={props.text}
        />
      ) : (
        <div className={css.BooksMenuDescription__Text}>
          {StringUtils.nl2br(props.text)}
        </div>
      )}
      {clampedState && (
        <button
          className={css.BooksMenuDescription__TruncateButton}
          onClick={ev => {
            ev.preventDefault();
            setEllipsis(!ellipsis);
          }}
        >
          {ellipsis
            ? props.intl.formatMessage({ id: 'books.booksMenu.truncateOpen' })
            : props.intl.formatMessage({ id: 'books.booksMenu.truncateClose' })}
        </button>
      )}
    </div>
  );
};

export default injectIntl(BooksMenuDescription);
